import {
  CLEAR_STAKE,
  DELETE_STAKE,
  DELETE_STAKE_FAIL,
  FETCH_ONE_STAKE,
  LOADING_ONE_STAKE,
  PATCH_STAKE,
  POST_STAKE,
} from "../actions/actionTypes";

const initialState = {
  id: 0,
  name: "",
  comment: "",
  axisId: {},
  projects: [],
  status: 0,
  isLoading: true,
};

const oneStakeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ONE_STAKE:
      return {
        ...state,
        id: action.payload.id,
        name: action.payload.name,
        comment: action.payload.comment,
        axisId: action.payload.axisId,
        projects: action.payload.projects,
        status: action.payload.status,
        isLoading: false,
      };
    case POST_STAKE:
      return {
        ...state,
        id: action.payload.id,
        name: action.payload.name,
        comment: action.payload.comment,
        axisId: action.payload.axisId,
        projects: action.payload.projects,
        status: action.payload.status,

        isLoading: false,
      };
    case PATCH_STAKE:
      return {
        ...state,
        id: action.payload.id,
        name: action.payload.name,
        comment: action.payload.comment,
        axisId: action.payload.axisId,
        projects: action.payload.projects,
        isLoading: false,
      };
    case DELETE_STAKE || DELETE_STAKE_FAIL:
      return {
        ...state,
        status: action.payload.status,
      };
    case CLEAR_STAKE:
      return initialState;
    case LOADING_ONE_STAKE:
      return {
        ...state,
        isLoading: true,
      };
    default:
      return {
        ...state,
      };
  }
};

export default oneStakeReducer;
